<template>
  <div class="container">
    <head-nav-bar title="走进医院" :fixed="true" />
    <div class="mt-header-nav">
      <van-card
        desc="描述信息"
        :thumb="$config.fileUrl + '/' + hospitalInfo.logo"
        style="background:#fff;"
      >
        <div slot="title">
          <div style="font-weight: bold; font-size:0.38rem;">
            {{ hospitalInfo.name }}
          </div>
          <div style="font-weight: bold; font-size:0.38rem;">
            {{ hospitalInfo.fullName }}
          </div>
        </div>
        <div slot="desc">
          <van-tag plain type="danger" size="small" style="margin: 0.2rem 0;">{{
            hospitalInfo.hospitalStarDesc
          }}</van-tag>
        </div>
        <div slot="tags">
          <div>{{ hospitalInfo.contactPersonPhone }}</div>
          <div>{{ hospitalInfo.address }}</div>
        </div>
      </van-card>
      <div class="kong"></div>
      <van-tabs v-model="active">
        <van-tab title="医院介绍">
          <div class="newstext" v-html="hospitalInfo.remark"></div>
        </van-tab>
        <van-tab title="名医推荐">
          <DataList api="Doctor_Recommend">
            <template v-slot:item="item">
              <div class="doctor-item" @click="toDoctorInfo(item.obj)">
                <doctor-card
                  :data="item.obj"
                  :enabledDisplayDutyTitle="enabledDisplayDutyTitle"
                />
              </div>
            </template>
          </DataList>
        </van-tab>
        <van-tab title="医院科室">
          <DataList api="Department_List">
            <template v-slot:item="item">
              <news-card
                :data="item.obj"
                titleField="name"
                descField="introduction"
                @click="toInfo(item.obj)"
                isKeShi
              />
            </template>
          </DataList>
        </van-tab>
        <van-tab title="公交路线">
          <div class="newstext" v-html="hospitalInfo.busRoutes"></div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { Card, Tag, Button, Tab, Tabs } from "vant";
import DataList from "@/components/DataList";
import NewsCard from "@/components/NewsCard";
import { mapState, mapActions } from "vuex";
import DoctorCard from "@/components/DoctorCard";
export default {
  components: {
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    DataList,
    NewsCard,
    DoctorCard,
  },
  data() {
    return {
      active: "",
      enabledDisplayDutyTitle: false,
    };
  },
  computed: {
    ...mapState({
      hospitalInfo: (state) => state.app.hospitalInfo,
    }),
  },
  created() {
    console.log(this.hospitalInfo);
    if (!(this.hospitalInfo && this.hospitalInfo.id)) {
      this.getHospitalInfo();
    }
    this.$post("GetWxSystemParameterInfo", {}).then((res) => {
      this.enabledDisplayDutyTitle = res.data.enabledDisplayDutyTitle;
    });
  },
  methods: {
    ...mapActions(["getHospitalInfo"]),
    toInfo(item) {
      this.$router.push({
        name: "hospitalDepartmentInfo",
        query: {
          Id: item.id,
        },
      });
    },
    toDoctorInfo(item) {
      this.$router.push({
        name: "hospitalDoctorInfo",
        query: {
          Id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
